/* @flow */

import type { $WidgetField } from 'CoreTypes/WidgetField';
import Keys from 'CoreConstants/WidgetDealerKeys';
import GenericKeys from 'CoreConstants/FieldKeysGeneric';

export default ([
  {
    fkey: Keys.DEALER_NAME_LINE_1,
    label: 'Dealer name 1'
  },
  {
    fkey: Keys.DEALER_NAME_LINE_2,
    label: 'Dealer name 2'
  },
  {
    fkey: Keys.DEALER_NAME_LINE_3,
    label: 'Dealer name 3'
  },
  {
    fkey: Keys.DEALER_NAME_LINE_4,
    label: 'Dealer name 4'
  },
  {
    fkey: Keys.DEALER_NAME_LINE_5,
    label: 'Dealer name 5'
  },
  {
    fkey: Keys.DEALER_HOMEPAGE,
    label: 'Dealer homepage'
  },
  {
    fkey: Keys.DEALER_ADDRESS_DISTANCE_DISTANCE,
    label: 'Dealer driving distance'
  },
  {
    fkey: Keys.DEALER_ADDRESS_DISTANCE_AIR_DISTANCE,
    label: 'Dealer air distance'
  },
  {
    fkey: Keys.DEALER_ADDRESS_LINE_1,
    label: 'Dealer address line 1',
  },
  {
    fkey: Keys.DEALER_ADDRESS_LINE_2,
    label: 'Dealer address line 2',
  },
  {
    fkey: Keys.DEALER_ADDRESS_LINE_3,
    label: 'Dealer address line 3',
  },
  {
    fkey: Keys.DEALER_ADDRESS_CITY,
    label: 'Dealer address city'
  },
  {
    fkey: Keys.DEALER_ADDRESS_ZIPCODE,
    label: 'Dealer address zipcode'
  },
  {
    fkey: Keys.DEALER_CONTACT_PHONE,
    label: 'Dealer contact phone',
    prefix: GenericKeys.PREFIX_PHONE,
    hasConvertableCountryNumber: true
  },
  {
    fkey: Keys.DEALER_CONTACT_FAX,
    label: 'Dealer contact fax',
    prefix: GenericKeys.PREFIX_FAX,
    hasConvertableCountryNumber: true
  },
  {
    fkey: Keys.DEALER_CONTACT_EMAIL,
    label: 'Dealer contact email',
    prefix: GenericKeys.PREFIX_EMAIL
  },
  {
    fkey: Keys.DEALER_C_ACTIVITY_TYPES,
    label: 'Dealer activity types'
  }
]: Array<$WidgetField>);
